
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Ticket, TicketCreate } from './ticket';
import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';


@Injectable({ providedIn: 'root' })
export class TicketService {
  constructor(private http: HttpClient) {
  }
  token = environment.token;
  ticketurl = environment.appURL + "/tickets";

  //----------------------------------------------------------------------------------
  // GET ALL TICKETS
  //----------------------------------------------------------------------------------

  getTicketes() {
    return this.http.get<Ticket[]>(this.ticketurl + "?_limit=500", { headers: new HttpHeaders({ "Authorization": "Bearer " + this.token }) }).pipe(tap(_ => { }), catchError(this.handleError('getTicketes', [])));
  }


getTicketsCount(status?: number, client?: number): Observable<number> {
  let params = new HttpParams();

  if (status !== undefined) params = params.set('status', status.toString());
  if (client !== undefined) params = params.set('client', client.toString());

  return this.http.get<number>(`${this.ticketurl}/count`, {
    headers: new HttpHeaders({ "Authorization": "Bearer " + environment.token }),
    params: params  // ✅ Automatically appends filters if provided
  }).pipe(
    catchError(this.handleError<number>('getTicketsCount', 0))
  );
}
  

  //----------------------------------------------------------------------------------
  // GET ALL TICKETS GRAPHQL 
  //----------------------------------------------------------------------------------

  getTicketsQl() {
    var query = "{tickets{ id machines {  id shortname serialnumber client{id name}} errorcode title  status{id status} user{username}  dispatchorder {id} dateofticket dateresolved details resolution client{id name} }}";
    const url = environment.graphURL + query;
    return this.http.get<Ticket[]>(url, { headers: new HttpHeaders({ "Authorization": "Bearer " + environment.token }) }).pipe(map(data => data['data']['tickets']));
  }

  //----------------------------------------------------------------------------------
  // GET TICKET BY ID
  //----------------------------------------------------------------------------------

  getTicket(id: number) {
    var query = "{ticket(id:" + id + " ){ id machines { shortname} dispatchorder {id} errorcode title  dateofticket dateresolved resolution status{status} user{username} }}";
    const url = environment.graphURL + query;
    return this.http.get<Ticket>(url, { headers: new HttpHeaders({ "Authorization": "Bearer " + environment.token }) }).pipe(map(data => data['data']['ticket']));
  }

  //----------------------------------------------------------------------------------
  // GET MACHINE TICKETS
  //----------------------------------------------------------------------------------

  getTicksetofMachine(id: number) {
    var query = "{tickets (where:{ machines:" + id + "}){user{username firstname lastname} dispatchorder {id} observer{id firstname lastname username} id machines { id shortname} errorcode title details resolution  comments {user{username avatar{url}} postedon content }attachment{id url} status{id status} dateofticket dateresolved}}"
    const url = environment.graphURL + query;
    return this.http.get<Ticket[]>(url, { headers: new HttpHeaders({ "Authorization": "Bearer " + environment.token }) }).pipe(map(data => data['data']['tickets']));
  }


  //----------------------------------------------------------------------------------
  // GET MACHINE TICKETS FROM API CALL
  //----------------------------------------------------------------------------------

  getTicksetofMachineLight(machine: number) {
    return this.http.get<Ticket[]>(this.ticketurl +"?machines="+ machine, { headers: new HttpHeaders({ "Authorization": "Bearer " + environment.token }) }).pipe(tap(_ => { }), catchError(this.handleError('getTicketes', [])));
  }


  //----------------------------------------------------------------------------------
  // GET USER TICKETS
  //----------------------------------------------------------------------------------

  getUserTickets(id: number, jwt: string) {
    var query = "{tickets (where:{ user:" + id + "}){user{username firstname lastname} dispatchorder {id} observer{id firstname lastname username} id machines { id shortname client{name}} errorcode title details resolution comments {user{username avatar{url}} postedon content }attachment{id url} status{id status} dateofticket dateresolved}}"
    const url = environment.graphURL + query;
    return this.http.get<Ticket[]>(url, { headers: new HttpHeaders({ "Authorization": "Bearer " + jwt }) }).pipe(map(data => data['data']['tickets']));
  }

  //----------------------------------------------------------------------------------
  // POST TICKET  / CREATE
  //----------------------------------------------------------------------------------

  createTicket(ticket: TicketCreate) {
    ticket.assigned_to = 32;
    var upd = JSON.stringify(ticket);
    return this.http.post<Ticket>(`${environment.appURL}/tickets/`, upd, { headers: new HttpHeaders({ "Authorization": "Bearer " + environment.token, "Content-Type": "application/json" }) });
  }

  //----------------------------------------------------------------------------------
  // ERROR HANDLING 
  //----------------------------------------------------------------------------------
  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      console.log(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  //----------------------------------------------------------------------------------
  // GET TICKET BY CRITERIA 
  //----------------------------------------------------------------------------------

  getTicketByCriteria(criteria: string, argument: string) {
    const url = this.ticketurl + "?" + criteria + "_contains=" + argument;
    return this.http.get<Ticket[]>(url, { headers: new HttpHeaders({ "Authorization": "Bearer " + environment.token }) }).pipe(tap(_ => { }), catchError(this.handleError('geMachineByShortname', [])));
  }

  //----------------------------------------------------------------------------------
  // GET CLIENT TICKETS BY CLIENT ID AND SEARCH CRITERIA
  //----------------------------------------------------------------------------------

  getTicketByCriteriaClient(criteria: string, argument: string, clientId: number, jwt: string) {
    var query = "{tickets (where:{ client:" + clientId + "," + criteria + "_contains:\"" + argument + "\"}){ client{id name} user{username firstname lastname} dispatchorder {id} observer{id firstname lastname username} id machines { id shortname serialnumber client{name}} errorcode title details resolution status{id status} dateofticket dateresolved }}";
    const url = environment.graphURL + query;

    return this.http.get<Ticket[]>(url, { headers: new HttpHeaders({ "Authorization": "Bearer " + environment.token }) })
      .pipe(map(data => data['data']['tickets'])
      );


  }

  //----------------------------------------------------------------------------------
  // GET CLIENT TICKETS BY CLIENT ID
  //----------------------------------------------------------------------------------

  getClientTickets(clientId: number) {
    var query = "{tickets (where:{ client:" + clientId + "}){ client{name} user{username firstname lastname} dispatchorder {id} observer{id firstname lastname username} id machines { id shortname serialnumber client{name}} errorcode title status{id status} dateofticket dateresolved resolution details }}"
    const url = environment.graphURL + query;
    return this.http.get<Ticket[]>(url, { headers: new HttpHeaders({ "Authorization": "Bearer " + environment.token }) }).pipe(map(data => data['data']['tickets']));
  }

  //----------------------------------------------------------------------------------
  // GET TICKET BY SEARCH CRITERIA GRAPHQL
  //----------------------------------------------------------------------------------

  getTicketsByCriteriaQl(criteria: string, argument: string) {
    var query = "{tickets (where:{" + criteria + "_contains:\"" + argument + "\"}){ client{name} user{username firstname lastname} dispatchorder {id} observer{id firstname lastname username} id machines { id shortname serialnumber client{name}} errorcode title status{id status} details dateofticket dateresolved resolution }}"
    const url = environment.graphURL + query;
    return this.http.get<Ticket[]>(url, { headers: new HttpHeaders({ "Authorization": "Bearer " + environment.token }) }).pipe(map(data => data['data']['tickets']));
  }

  //----------------------------------------------------------------------------------
  // GET CLIENT TICKETS BY CLIENT NAME GRAPHQL
  //----------------------------------------------------------------------------------

  getTicketsByClientNameQl(criteria: string, argument: string) {
    var query = "{tickets (where:{client:{name_contains:\"" + argument + "\"}}){ client{name} user{username firstname lastname} dispatchorder {id} observer{id firstname lastname username} id machines { id shortname serialnumber client{name}} errorcode title status{id status} details dateofticket dateresolved resolution }}"
    const url = environment.graphURL + query;
    return this.http.get<Ticket[]>(url, { headers: new HttpHeaders({ "Authorization": "Bearer " + environment.token }) }).pipe(map(data => data['data']['tickets']));
  }


  //----------------------------------------------------------------------------------
  // GET CLIENT TICKETS BY CLIENT NAME AND DATE RANGE FROM -> TO
  //----------------------------------------------------------------------------------

  getTicketsByClientDateRangeQl(argument: string, dateFrom: Date, dateTo: Date) {
    var query = "{tickets (where:{client:{name_contains:\"" + argument + "\"}, dateofticket_lt:\"" + dateTo + "\", dateofticket_gte:\"" + dateFrom + "\"}){ client{name} user{username firstname lastname} dispatchorder {id} observer{id firstname lastname username} id machines { id shortname serialnumber client{name}} errorcode title status{id status} details dateofticket dateresolved resolution }}"
    const url = environment.graphURL + query;
    return this.http.get<Ticket[]>(url, { headers: new HttpHeaders({ "Authorization": "Bearer " + environment.token }) }).pipe(map(data => data['data']['tickets']));
  }

  //----------------------------------------------------------------------------------
  // GET TICKETS BY Criteria AND DATE RANGE FROM -> TO
  //----------------------------------------------------------------------------------
 getTicketsByCriteriaDateRangeQl(criteria: string, argument: string, dateFrom: Date, dateTo: Date) {
    var query = "{tickets (where:{" + criteria + "_contains:\"" + argument + "\", dateofticket_lt:\"" + dateTo + "\", dateofticket_gte:\"" + dateFrom + "\"}){ client{name} user{username firstname lastname} dispatchorder {id} observer{id firstname lastname username} id machines { id shortname serialnumber client{name}} errorcode title status{id status} dateofticket dateresolved resolution }}"
    const url = environment.graphURL + query;
    return this.http.get<Ticket[]>(url, { headers: new HttpHeaders({ "Authorization": "Bearer " + environment.token }) }).pipe(map(data => data['data']['tickets']));
  }

  //----------------------------------------------------------------------------------
  // GET TICKETS BY DATE RANGE FROM -> TO
  //----------------------------------------------------------------------------------
  getTicketsByDateRangeQl( dateFrom: Date, dateTo: Date) {
    var query = "{tickets (where:{ dateofticket_lt:\"" + dateTo + "\", dateofticket_gte:\"" + dateFrom + "\"}){ client{name} user{username firstname lastname} dispatchorder {id} observer{id firstname lastname username} id machines { id shortname serialnumber client{name}} errorcode title status{id status} details dateofticket dateresolved resolution }}"
    const url = environment.graphURL + query;
    return this.http.get<Ticket[]>(url, { headers: new HttpHeaders({ "Authorization": "Bearer " + environment.token }) }).pipe(map(data => data['data']['tickets']));
  }

  //----------------------------------------------------------------------------------
  // GET CLIENT TICKETS BY CLIENT NAME && DATE RANGE FROM -> TO && Criteria
  //----------------------------------------------------------------------------------
  getTicketsByClientCriteriaDateRangeQl(clientName : String, criteria : string , argument: string, dateFrom: Date, dateTo: Date) {
    var query = "{tickets (where:{client:{name_contains:\"" + clientName + "\"}, " + criteria + "_contains:\"" + argument + "\" , dateofticket_lt:\"" + dateTo + "\", dateofticket_gte:\"" + dateFrom + "\"}){ client{name} user{username firstname lastname} dispatchorder {id} observer{id firstname lastname username} id machines { id shortname serialnumber client{name}} errorcode title status{id status} details dateofticket dateresolved resolution }}"
    const url = environment.graphURL + query;
    return this.http.get<Ticket[]>(url, { headers: new HttpHeaders({ "Authorization": "Bearer " + environment.token }) }).pipe(map(data => data['data']['tickets']));
  }


  deleteTicket(id : number): Observable<any> {
const urld = this.ticketurl + "/" + id; 
return this.http.delete<Ticket>(urld, { headers: new HttpHeaders({ "Authorization": "Bearer " + this.token }) }).pipe(tap(_ => { }), catchError(this.handleError('getDispatchOrders', [])));
  }


}
